import { Controller } from "@hotwired/stimulus"

/** Removes the host element (used to hide one-shot banners without a request). */
export default class extends Controller {
  dismiss(event) {
    event.preventDefault()
    this.element.remove()
  }
}
